import { Link } from 'react-router-dom';
import SectionHeading from '../components/SectionHeading';
import ArticleCard from '../../../components/ArticleCard';
import { HERO_ARTICLES } from '../../../config/article-mappings';

export default function BlogPreviewSection() {
  return (
    <section id="blog" className="ee-landing-section">
      <div className="ee-landing-container ee-landing-container--mid">
        <SectionHeading
          title="From the Blog"
          subtitle="Free in-depth guides to help you communicate with more empathy and less friction."
        />

        <div className="ee-landing-grid ee-landing-grid--3">
          {HERO_ARTICLES.map((article, index) => (
            <ArticleCard
              key={article.slug}
              title={article.title}
              slug={article.slug}
              category={article.category}
              readingTime={article.readingTime}
              excerpt={article.excerpt}
              index={index}
              look="landing"
            />
          ))}
        </div>

        <div className="ee-landing-more-row">
          <Link to="/learn" className="ee-landing-more">
            View all articles
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
